import { render, staticRenderFns } from "./CreateAbsenceSlidebar.vue?vue&type=template&id=6f933fc6"
import script from "./CreateAbsenceSlidebar.vue?vue&type=script&lang=js"
export * from "./CreateAbsenceSlidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports